import React from 'react';
import { motion } from 'framer-motion';
import '../styles/LoadingSpinner.scss';

const LoadingSpinner = () => {
    return (
        <div className="loading-spinner-container">
            <motion.div
                className="loading-spinner"
                animate={{
                    rotate: 360
                }}
                transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: "linear"
                }}
            >
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
            </motion.div>
            <p className="loading-text">Loading...</p>
        </div>
    );
};

export default LoadingSpinner;
